var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCofe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 235,
    viewBox: "0 0 152 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 66.6206H148.386V50.9654L87.9 50.9655H64.4861L4 50.9654V66.6206Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4861 50.9655H87.9V4H64.4861V50.9655Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.679 90.1035L138.63 66.6207H13.7558L15.707 90.1035H136.679Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.33 176.207L144.483 90.1035H7.90241L15.0569 176.207L22.8609 176.207H129.525L137.33 176.207Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.525 176.207H22.8609L27.4139 231H124.972L129.525 176.207Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 50.9654V66.6206H148.386V50.9654M4 50.9654H148.386M4 50.9654L64.4861 50.9655M148.386 50.9654L87.9 50.9655M87.9 50.9655H64.4861M87.9 50.9655V4H64.4861V50.9655M137.33 176.207L144.483 90.1035H7.90241L15.0569 176.207M137.33 176.207H15.0569M137.33 176.207L129.525 176.207M15.0569 176.207L22.8609 176.207M22.8609 176.207L27.4139 231H124.972L129.525 176.207M22.8609 176.207H129.525M136.679 90.1035L138.63 66.6207H13.7558L15.707 90.1035H136.679Z",
    stroke: "black",
    strokeWidth: 6.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1187 155.297C44.9746 146.129 47.4458 128.781 59.6366 116.551C71.8284 104.32 89.1245 101.845 98.2676 111.013C107.412 120.181 104.941 137.529 92.7497 149.759M54.1187 155.297C63.2619 164.465 80.5579 161.99 92.7497 149.759M54.1187 155.297C54.0524 155.229 54.0005 155.151 53.9361 155.082C55.177 150.943 56.5887 146.746 61.9544 141.364C73.1667 130.112 79.2221 136.188 90.4354 124.946C95.7982 119.564 97.2099 115.367 98.4508 111.228C107.361 120.445 104.853 137.617 92.7497 149.759",
    stroke: "black",
    strokeWidth: 6.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7789 211.431C52.7789 215.756 49.2844 219.259 44.9743 219.259C40.6642 219.259 37.1697 215.756 37.1697 211.431C37.1697 207.106 40.6642 203.603 44.9743 203.603C49.2844 203.603 52.7789 207.106 52.7789 211.431Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7789 187.948C52.7789 192.273 49.2844 195.776 44.9743 195.776C40.6642 195.776 37.1697 192.273 37.1697 187.948C37.1697 183.624 40.6642 180.121 44.9743 180.121C49.2844 180.121 52.7789 183.624 52.7789 187.948Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.216 191.862C115.216 196.187 111.722 199.69 107.412 199.69C103.101 199.69 99.6069 196.187 99.6069 191.862C99.6069 187.537 103.101 184.035 107.412 184.035C111.722 184.035 115.216 187.537 115.216 191.862Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.216 211.431C115.216 215.756 111.722 219.259 107.412 219.259C103.101 219.259 99.6069 215.756 99.6069 211.431C99.6069 207.106 103.101 203.603 107.412 203.603C111.722 203.603 115.216 207.106 115.216 211.431Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1929 211.431C76.1929 215.756 72.6983 219.259 68.3882 219.259C64.0781 219.259 60.5836 215.756 60.5836 211.431C60.5836 207.106 64.0781 203.603 68.3882 203.603C72.6983 203.603 76.1929 207.106 76.1929 211.431Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7043 207.517C95.7043 211.842 92.2098 215.345 87.8997 215.345C83.5896 215.345 80.0951 211.842 80.0951 207.517C80.0951 203.193 83.5896 199.69 87.8997 199.69C92.2098 199.69 95.7043 203.193 95.7043 207.517Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1929 187.948C76.1929 192.273 72.6983 195.776 68.3882 195.776C64.0781 195.776 60.5836 192.273 60.5836 187.948C60.5836 183.624 64.0781 180.121 68.3882 180.121C72.6983 180.121 76.1929 183.624 76.1929 187.948Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7043 184.034C95.7043 188.359 92.2098 191.862 87.8997 191.862C83.5896 191.862 80.0951 188.359 80.0951 184.034C80.0951 179.71 83.5896 176.207 87.8997 176.207C92.2098 176.207 95.7043 179.71 95.7043 184.034Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCofe);
export default __webpack_public_path__ + "static/media/cofe.ace87797fe4f7e106779ea06de3cf7f0.svg";
export { ForwardRef as ReactComponent };